import React from 'react';
import { Text } from '@chakra-ui/react';
import { PageWrapper } from '../components/PageWrapper';
import { theme } from '../constants/theme';

function SettingsPage() {
  return (
    <PageWrapper maxWidth={theme.layout.pageMaxWidth}>
      <Text fontSize="2xl" fontWeight="bold">Settings</Text>
      <Text color="gray.500">Settings page will be implemented later.</Text>
    </PageWrapper>
  );
}

export default SettingsPage;